import { render, staticRenderFns } from "./CVTypeSchoolActivity.vue?vue&type=template&id=4708780a"
import script from "./CVTypeSchoolActivity.vue?vue&type=script&lang=js"
export * from "./CVTypeSchoolActivity.vue?vue&type=script&lang=js"
import style0 from "./CVTypeSchoolActivity.vue?vue&type=style&index=0&id=4708780a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports